export const TMD_QUIZ_MODAL = 'TMD_QUIZ_MODAL';
export const TMD_QUIZ_FORM = 'TMD_QUIZ_FORM';
export const TMD_WARNING_MODAL = 'TMD_WARNING_MODAL';
export const TMD_SUCCESS_MODAL = 'TMD_SUCCESS_MODAL';
export const TMD_LOCKED_MODAL = 'TMD_LOCKED_MODAL';
export const TMD_CHECK_MODAL = 'TMD_CHECK_MODAL';
export const TMD_FAILED_LOGOUT_TIMEOUT = 30000;
